import React from 'react';
import Spacer from '../../../../components/Spacer/Spacer';
import { calculateTeamPoints } from './utils';

const Phase1Tab = ({ player, realResults }) => {
  return (
    <>
      <div className="guess-section">
        <h3 className="guess-section-title">Liga Stilling</h3>
        {player.leagueStanding && player.leagueStanding.length > 0 ? (
          <div className="guess-content">
            <div className="league-standing-display">
              {player.leagueStanding.map((team, index) => {
                const teamPoints = calculateTeamPoints(team, index, realResults);
                const pointsClass = teamPoints > 0 ? 'team-points-positive' : 'team-points-zero';
                
                return (
                  <div key={index} className="standing-item">
                    <span className="position">{index + 1}.</span>
                    <span className="team-name">{team}</span>
                    <span className={`team-points ${pointsClass}`}>{teamPoints}</span>
                  </div>
                );
              })}
            </div>
            <p className="guess-points">
              Point: {player.phase1Points || 0}
            </p>
          </div>
        ) : (
          <p className="no-guess">Ikke gættet endnu</p>
        )}
      </div>
      {player.leagueStanding && player.leagueStanding.length > 0 && (
        <Spacer size="100px" />
      )}
    </>
  );
};

export default Phase1Tab;

